import { RouteConfig } from 'vue-router'

const routes: Array<RouteConfig> = [
  {
    path: '*',
    component: () => import('@/views/Index.vue'),
    children: [
      {
        path: '/payment/success',
        name: 'payment_success',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/payment/fail',
        name: 'payment_fail',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/newsletter-subscribe/:token',
        name: 'newsletter_subscribe',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/newsletter-unsubscribe/:token',
        name: 'newsletter_unsubscribe',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/account-activation/:token',
        name: 'account_activation',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/password-reset/:token',
        name: 'password_reset',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/bookings/:control',
        name: 'booking_control',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/subscription/:id',
        name: 'subscription',
        component: () => import('@/views/Subscription.vue')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('@/views/Account.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/payments',
        name: 'payments',
        component: () => import('@/views/Payments.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/bookings',
        name: 'bookings',
        component: () => import('@/views/Bookings.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/subscriptions',
        name: 'subscriptions',
        component: () => import('@/views/Subscriptions.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '*',
        name: 'home',
        component: () => import('@/views/Home.vue')
      }
    ]
  }
]

export default routes
